import React, { useEffect, useState } from "react";
import { toast } from "sonner";

interface ImageWithFallbackProps {
  src: string;
  fallbackSrc: string;
  alt?: string;
  className?: string;
}

export const ImageWithFallback = ({
  src,
  fallbackSrc,
  alt = "Image",
  className = "",
}: ImageWithFallbackProps): React.JSX.Element => {
  const [imgSrc, setImgSrc] = useState(src);

  const handleError = (): void => {
    if (imgSrc !== fallbackSrc) {
      setImgSrc(fallbackSrc);
    } else {
      toast.error("Failed to load fallback image.");
    }
  };

  useEffect(() => {
    if (src !== imgSrc) {
      setImgSrc(src);
    }
  }, [src]);

  return (
    <img
      src={imgSrc}
      alt={alt}
      className={`object-contain max-w-full max-h-full p-2 min-h-60 min-w-60 ${className}`}
      onError={handleError}
    />
  );
};
